import { render, staticRenderFns } from "./FixedCollectionParameter.vue?vue&type=template&id=f7ed85c2&scoped=true&"
import script from "./FixedCollectionParameter.vue?vue&type=script&lang=ts&"
export * from "./FixedCollectionParameter.vue?vue&type=script&lang=ts&"
import style0 from "./FixedCollectionParameter.vue?vue&type=style&index=0&id=f7ed85c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ed85c2",
  null
  
)

export default component.exports